



























import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class ScheduleEventListItem extends Vue {
  @Prop({ required: true }) eventId!: number;
  @Prop({ required: true }) date!: string;
  @Prop({ required: true }) start!: string;
  @Prop({ required: true }) end!: string;
  @Prop({ required: true }) projectName!: string;
  @Prop({ required: true }) title!: string;
  @Prop({ required: true }) description!: string;
  @Prop({ required: true }) tasks!: [];
  @Prop({ type: Boolean }) editable!: boolean;

  edit() {
    this.$emit("edit", this.eventId);
  }
}
